import axios from "axios";
import { dataEnv } from "../../config/index.js";
const API_BASE_URL = dataEnv().API_URL;

/**
 * Function to create list
 * @param {Object} payload
 * @return AxiosPromise
 */
export const createList = (payload) => {
  return axios.post(`${API_BASE_URL}/source-list`, payload);
};

/**
 * Function to post list
 * @param {Object} formData
 * @return AxiosPromise
 */
export const postList = (formData) => {
  return axios.post(`${API_BASE_URL}/upload/list`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Function to get list
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getList = (clientId) => {
  return axios.get(`${API_BASE_URL}/${clientId}/source-list`);
};
